import React from 'react'

import styled from '@emotion/styled'
import sv from '../styles/marketing'
import {requestHelper} from '../_helpers'
import {SvgGistifyLogo, SvgGistifyLogoTm} from "../icons/GistifyLogo"

// STYLE ##########################################################seed drill

const StyledLogo = styled(`div`)`
  ${sv.flexCenter};
  cursor: pointer;
  width: ${props => props.w};
`;

// COMPONENT ##########################################################

const TimeCloudLogo = ({color=sv.colors.headline, redirect=true, width="100px", tm=false}) => {
  const Logo = tm ? SvgGistifyLogoTm : SvgGistifyLogo;
  return (
    <StyledLogo w={width} className="logo" onClick={() => (redirect) ? requestHelper.goToHomePage() : ''}>
        <Logo fill={color} width={width} />
    </StyledLogo>
  )

};

export default TimeCloudLogo;

